import { Box, Grid, Skeleton } from "@mui/material";
import { FC } from "react";

type SkeletonLoadProps = {
  variant?: "table" | "form" | "cards";
  rows?: number;
  columns?: number;
};

const SkeletonLoad: FC<SkeletonLoadProps> = ({
  variant = "table",
  rows = 5,
  columns = 4,
}) => {
  if (variant === "form") {
    return (
      <Grid container spacing={2}>
        {Array.from({ length: rows }).map((_, index) => (
          <Grid item xs={12} md={index < 2 ? 6 : 12} key={index}>
            <Skeleton animation="wave" variant="text" width="35%" height={24} />
            <Skeleton animation="wave" variant="rounded" height={index < 2 ? 56 : 92} />
          </Grid>
        ))}
      </Grid>
    );
  }

  if (variant === "cards") {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {Array.from({ length: rows }).map((_, index) => (
          <Box key={index}>
            <Skeleton animation="wave" variant="rounded" height={120} />
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box sx={{ display: "grid", gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: 1 }}>
        {Array.from({ length: columns }).map((_, index) => (
          <Skeleton animation="wave" variant="text" height={32} key={index} />
        ))}
      </Box>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <Box
          sx={{ display: "grid", gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: 1 }}
          key={rowIndex}
        >
          {Array.from({ length: columns }).map((_, columnIndex) => (
            <Skeleton
              animation="wave"
              variant="rounded"
              height={36}
              key={`${rowIndex}-${columnIndex}`}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default SkeletonLoad;
